import React from 'react';
import { IM_CUSTOM_MESSAGE } from '@/typings/global';

function CustomFallback({ text }: { text?: string }): JSX.Element {
    return <div className="im-message-content">{text || '[暂不支持展示该类型消息]'}</div>;
}

function MsgCustom({ message }: { message: IM_CUSTOM_MESSAGE }): JSX.Element {
    try {
        const view = IM.SDKServer.renderCustomMessage(message);
        if (!view) {
            return <CustomFallback text={message.fallbackText} />;
        }
        if (view.kind === 'html') {
            if (typeof view.content !== 'string') {
                throw new Error('HTML 业务消息视图 content 必须是字符串');
            }
            return (
                <div
                    onClick={IM.SDKServer.DomClick}
                    dangerouslySetInnerHTML={{ __html: view.content }}
                />
            );
        }

        if (view.kind !== 'react' || !React.isValidElement(view.content)) {
            throw new Error('React 业务消息视图 content 必须是 React Element');
        }
        return view.content as React.ReactElement;
    } catch (error) {
        console.error(`业务消息渲染失败：${message.type}@${message.version}`, error);
        return <CustomFallback text={message.fallbackText} />;
    }
}

export default MsgCustom;
